export const codeColorMap = {
    dx: 'rgb(100,126,255)',
    tx: 'rgb(255,128,128)',
    other: '#6bc459',
    unknown: '#8d8d8d',
};

export const codeColorMapHover = {
    dx: 'rgb(20,59,255)',
    tx: 'rgb(255,0,0)',
    other: '#16a800',
    unknown: '#5a5a5a',
};
